"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { pageview } from "@/lib/gtag";

export function Analytics() {
    const pathname = usePathname();

    useEffect(() => {
        const url = pathname + window.location.search;
        pageview(url);
    }, [pathname]);

    return null;
}